import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Pillars from "@/components/site/Pillars";
import Testimonials from "@/components/site/Testimonials";
import Insights from "@/components/site/Insights";
import ApplicationForm from "@/components/site/ApplicationForm";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";
import ScrollProgress from "@/components/site/ScrollProgress";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-ink text-bone min-h-screen">
      <ScrollProgress />
      <Navbar />
      <Hero />
      <About />
      <Pillars />
      <Testimonials />
      <Insights />
      <ApplicationForm />
      <Faq />
      <Footer />
    </main>
  );
}
